import { formatMoney } from "./numbers";
import { dateShortFormat } from "../date_helpers";

export default {
  install(Vue) {
    Vue.filter("formatMoney", formatMoney);
    Vue.filter("shortDate", dateShortFormat);
  },
};
